import { DateTime } from '@ksyos/date-time';
import type { ICustomControlProcedureReadProps } from '../../interfaces/';
import { getServiceLabel } from '../../../../../../common/customControls/getServiceLabel';
import { ProcedureStatus } from '../../../../../../common/enums/procedureStatus';
import { getDisplayName } from '../../../../../../common/utils/getDisplayName';
import { translateKey } from '../../../../../translate';
import { useEpisodeContext } from '../../../../../utils/hooks/useEpisodeContext';
import { ProcedureReadButtons } from '../../../../elements/carePathButtons/ProcedureReadButtons';
import { FormLabel, FormParagraph } from '../../../../elements/common';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';
import { ProcessContainer } from '../../../episodes/common';
import { ProcessItemHeader } from '../../../episodes/ProcessItemHeader';
import { OsasV1QuestionnairesRead } from '../../utils/v1/questionnaires/OsasQuestionnairesRead';

export function OsasqV1ProcedureRead(props: ICustomControlProcedureReadProps) {
    const { patient } = useEpisodeContext();

    if (!props.request.customControlData) {
        return null;
    }

    return (
        <ProcessContainer>
            <ProcessItemHeader
                date={props.process.procedure && (props.process.procedure.dateSent ?? props.request.dateSent)}
                isFirstItem
                isFirstProcess={props.itemState.isFirstProcess}
                isItemOpen={props.itemState.isOpen}
                onToggle={async (isOpened) => await props.updateItemState({ ...props.itemState, isOpen: isOpened })}
                organizationName={
                    patient.authorization?.canSeePatientDetails && props.process.procedure?.performerOrganization?.name
                        ? props.process.procedure.performerOrganization.name
                        : undefined
                }
                practitionerName={
                    patient.authorization &&
                    patient.authorization.canSeePatientDetails &&
                    props.process.procedure &&
                    props.process.procedure.performerPractitioner
                        ? getDisplayName(props.process.procedure.performerPractitioner)
                        : undefined
                }
                process={props.process}
                serviceType={props.process.serviceType}
                showProcessIcon
                title={getServiceLabel(props.process.code, 'procedure', props.process.name)}
            />

            {props.request.customControlData.email_address && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('common.emailAddress')}</FormLabel>
                    <InputContainer className="mb-3">
                        <FormParagraph>{props.request.customControlData.email_address}</FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            {props.request.customControlData.resend_date && (
                <HorizontalFormGroupRead>
                    <FormLabel>{translateKey('processThirdPartyMessages.nextScheduledDateTime')}</FormLabel>
                    <InputContainer>
                        <FormParagraph>
                            {DateTime.from(props.request.customControlData.resend_date).format('DD-MM-YYYY')}
                        </FormParagraph>
                    </InputContainer>
                </HorizontalFormGroupRead>
            )}

            <OsasV1QuestionnairesRead {...props} />

            {props.request.customControlData.manuallyRequested &&
                props.procedure.status === ProcedureStatus.completed && <ProcedureReadButtons {...props} />}
        </ProcessContainer>
    );
}
